import React, {Component} from 'react';
import {Redirect, Link} from 'react-router-dom';
import {isEmpty} from 'lodash';
import {getToken, getUser} from '../../utils/TokenManager';
import logo from '../../public/assets/images/symphony_logo_new_2021.png';
import loginImg from '../../public/assets/images/login-img.jpg';
import FormValidator from '../../validations/FormValidator';
import {ValidationRules} from './ValidationRules';
import {ToastContainer, toast} from 'react-toastify';
import FadeLoader from 'react-spinners/FadeLoader';
import {css} from 'react-emotion';
import {ROLL_ADMIN_SUPPORT} from '../common/Constants';

const override = css`
    margin: auto;
`;

export default class Login extends Component {
    state = {
        disabled: false,
        isLoading: false,
        errors: {},
        credentials: {
            username: '',
            password: ''
        },
    };
    validator = new FormValidator(ValidationRules);

    updateMessageState = (event) => {
        const field = event.target.name;
        let message = Object.assign({}, this.state.message);
        let value = '';
        if (event.target.type === 'file') {
            value = event.target.files[0];
        } else {
            value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        }

        message[field] = value;
        this.validateEachInput(field, message[field]);

        const credentials = Object.assign({}, this.state.credentials);
        credentials[event.target.name] = event.target.value;
        this.setState({credentials});
        return true;
    };

    validateEachInput = (field, value) => {
        let validationStatus = this.validator.validateInput(field, value);
        const errors = Object.assign({}, this.state.errors);
        errors[field] = '';
        if (!validationStatus.isValid) {
            errors[field] = validationStatus.error;
        }

        this.setState({errors});
        return true;
    };

    onChange = (event) => {
        const field = event.target.name;
        const value = event.target.value;
        const credentials = Object.assign({}, this.state.credentials);
        credentials[field] = value;
        return this.setState({credentials}, () => this.validateEachInput(field, value));
    };

    validateAndSubmit = async () => {
        const {credentials} = this.state;
        const {logIn} = this.props;
        let validationStatus = this.validator.validateForm(credentials);
        if (!validationStatus.isValid) {
            this.setState({errors: validationStatus.errors});
        } else {
            this.setState({
                isLoading: true
            }, async () => {
                try {
                    const result = await logIn(credentials);
                    if (result) {
                        this.setState({isLoading: false});
                        toast.success("Login successfully", {
                            position: toast.POSITION.TOP_CENTER
                        });
                    }
                } catch (error) {
                    this.setState({isLoading: false});
                    try {
                        toast.dismiss();
                    } catch (err) {}

                    toast.error("Email or password doesn't match");
                }
            });
        }

        return true;
    };

    checkAuth = () => {
        if (!this.state.isLoading) {
            this.validateAndSubmit();
        }
    };

    render() {
        const {credentials, errors, isLoading} = this.state;
        const {auth} = this.props;
        const user = getUser();

        if (auth.isAuthenticated || (typeof getToken() && !isEmpty(getToken()))) {
            if (user.is_installation_completed) {
                let prevURL = this.props.prevURL;
                if (user.role.access_level_value === ROLL_ADMIN_SUPPORT) {
                    prevURL = '/dashboard';
                } else if (
                    prevURL === '/' || prevURL === '/login' || 
                    prevURL === '/recovery' || prevURL === '/reset-password'
                ) {
                    prevURL = '/home';
                }
                return (<Redirect to={prevURL} />);
            } else {
                return (<Redirect to="/installation-wizard" />);
            }
        }
        return (
            <div className="login-page">
                <div className="login-box">
                    <div className="left-login-box">
                        <img src={loginImg} height="100%" alt="Login" />
                    </div>
                    <div className="right-login-box">
                        <img src={logo} alt="Logo" className="login-logo" />
                        <form className="auth-form">
                            <div className="border p-3">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text bg-success text-white text-center">
                                            <i className="fa fa-user" style={{width: '14px'}}/>
                                        </span>
                                    </div>
                                    <input className="form-control form-control-lg"
                                        placeholder="Email"
                                        name="username"
                                        required type="email"
                                        value={credentials.username} 
                                        onChange={this.onChange}
                                    />
                                    {errors.username ? 
                                        <span className="span-error">
                                            {errors.username}
                                        </span> 
                                        : ''
                                    }
                                </div>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text bg-warning text-white">
                                            <i className="fa fa-key"/>
                                        </span>
                                    </div>
                                    <input className="form-control form-control-lg" 
                                        placeholder="Password" 
                                        name="password" 
                                        required type="password" 
                                        value={credentials.password} 
                                        onChange={this.onChange}
                                    />
                                    {errors.password ? 
                                        <span className="span-error">
                                            {errors.password}
                                        </span> 
                                        : ''
                                    }
                                </div>
                                <hr/>
                                <div className="form-group mb-0">
                                    {isLoading ?
                                        <FadeLoader
                                            color={'#4fb8a5'}
                                            loading={isLoading}
                                            size={24}
                                            className={override}
                                        /> :
                                        <div className="d-flex flex-column align-items-center">
                                            <button onClick={this.checkAuth} 
                                                //style ={{backgroundColor:"#ef8e2a"}}
                                                className="btn btn-success w-50 font-weight-bold" 
                                                type="submit"
                                            >Login</button>
                                            <Link to='/recovery' className="a-text-underline mt-2">
                                                Forgot password? 
                                            </Link>
                                        </div>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="mt-2 text-center">
                    <q className="text-left">
                        <i>
                            Success is not final. Failure is not fatal. 
                            It's the courage to continue that counts.
                        </i>
                    </q>
                    <b> - Winston Churchill</b>
                </div>
                <div className="clear login-footer">
                    <p>
                        Need Help? Call Support at 972-961-4798 
                        or email at tom@comp21.biz or
                        <a className="text-success" 
                            href="https://us02web.zoom.us/j/9722396890"
                        > Click Here </a> for a Zoom meeting
                    </p>
                </div>
                <ToastContainer position={toast.POSITION.TOP_CENTER} autoClose={2000}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/login/Login.js